/**
 * NAV-ITEM
 * Menu top button
 */
import { faCaretDown, IconDefinition } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useState } from "react"
import { connect } from "react-redux"
import ContextMenu from "./context-menu"
import { Session } from "@/redux/_session.types"
import Space from "./space"
import { NavigateFunction, useNavigate } from "react-router-dom"

interface StateProps {
  _session: Session
}

interface OwnProps {
  children?: any //Items for context menu
  icon?: IconDefinition //Icon of button
  isMenuRightAlign?: boolean //Align the subItems menu
  pathname: string //Page to navigate to
  title?: string //Text to display
  tooltip?: string //Text data-tip
  asChip?: boolean //Display as chip
  onClick?: () => void
}

type Props = StateProps & OwnProps

function NavItem(props: Props) {
  const navigate: NavigateFunction = useNavigate()

  //Open context
  const [isChildrenVisible, setIsChildrenVisible] = useState(false)

  const chipStyle = props.asChip
    ? { border: "1px solid white", padding: "4px 16px", borderRadius: "16px", marginLeft: "6px" }
    : undefined

  //Action on clic
  function click() {
    if (props.onClick) {
      props.onClick()
    } else {
      navigate(props.pathname)
    }
  }

  //Close menu
  function closeContextMenu() {
    setIsChildrenVisible(false)
  }

  //Classname
  //If page match with current page > highlight button
  function getClassname() {
    let className = "menutop-item flex"

    if (props.children) {
      if (props.pathname.split("/")[1] === window.location.pathname.split("/")[1]) {
        className = className + " menutop-item-opacity"
      }
    } else if (props.pathname === window.location.pathname) {
      className = className + " menutop-item-opacity"
    }

    return className
  }

  //Color of text
  function getStyle() {
    return {
      color: props._session.accountColors.brandText
    }
  }

  return (
    <div
      id={props.pathname.replaceAll("/", "_")}
      className="rel"
      onMouseLeave={props.children ? () => setIsChildrenVisible(false) : undefined}>
      <div
        className={getClassname()}
        title={props.tooltip}
        onMouseEnter={props.children ? () => setIsChildrenVisible(true) : undefined}
        onClick={click}
        style={getStyle()}>
        <div className="menutop-item-content flex">
          <div className="flex flex-dcol">
            <Space />
            {props.icon && <FontAwesomeIcon icon={props.icon} />}
            <Space />
          </div>

          <div className="menutop-item-dropdown" style={chipStyle}>
            {props.title && <span style={{ marginLeft: 6 }}>{props.title}</span>}
            {props.children && <FontAwesomeIcon icon={faCaretDown} />}
          </div>
        </div>
      </div>

      {isChildrenVisible && (
        <ContextMenu positionRight={props.isMenuRightAlign} onClose={closeContextMenu}>
          {props.children}
        </ContextMenu>
      )}
    </div>
  )
}

const mapStateToProps = (state) => ({
  _session: state._session
})

export default connect(mapStateToProps)(NavItem)
